export default __webpack_public_path__ + "static/media/bg1.7682fe43.jpg";